import { APP_ROUTES } from 'src/app/routes/routes.constants'

export const COOKIE_INTEGRATION_BACKOFFICE = 'integrationBkf'
export const COOKIE_INTEGRATION_NAME = 'hmVlcIntegration'
export const COOKIE_INTEGRATION_BW_CENTRAL = 'integrationBWCentral'
export const COOKIE_LAST_NAVIGATE_ROUTE = 'LAST_NAVIGATE_ROUTE'
export const LOCALSTORAGE_TOKEN_NAME = 'token'
export const EXPIRE_DATE_TOKEN_NAME = 'hmSsoExp'
export const DOMAINS = {
  production: 'hotmart.com',
  development: 'buildstaging.com'
}
export enum REQUEST_SECURITY {
  'LOGIN' = 'oauth.login',
  'LOGOUT' = 'user.logout',
  'CHECK_TOKEN' = 'oauth.token.check',
  'ADD_SIGNUP_ROLE' = 'oauth.signup.role'
}
export const generateSSOpathLogout = () =>
  `${process.env.URL_SSO}/logout?post_logout_redirect_uri=${encodeURI(`${location.origin}${APP_ROUTES.cas.login}`)}`
